import {Pipe, PipeTransform} from "@angular/core";
import {SimConfigurationService} from "@services";
import {environment} from "../../../environments/environment";
import {SimUser} from "@models";

/**
 * UserImage Pipe fetches Image by Initials
 */
@Pipe({
	name: "userImage",
	standalone: false,
})
export class UserImagePipe implements PipeTransform {
	constructor() {}

	/**
	 * Generates User Initials Link
	 *
	 * @param user {SimUser}
	 * @param args
	 */
	transform(user: SimUser, args?: any): string {
		if (environment.mocking) {
			if (user) {
				return environment.baseHref + "/assets/fakeBackend/responses/GET_-api-User-UserImageByUserId_MockSystem.svg";
			} else {
				return SimConfigurationService.settings.webUserImageUrl.replace("{0}", "-1");
			}
		} else {
			if (user) {
				return SimConfigurationService.settings.webUserImageUrl.replace("{0}", user.id);
			} else {
				return SimConfigurationService.settings.webUserImageUrl.replace("{0}", "-1");
			}
		}
	}
}
